import React from "react";
import { Box, Grid, Typography } from "@mui/material";

// ✅ Import your images
import gallery1 from "../../assets/nw/5.png";
import gallery2 from "../../assets/nw/6.png";
import gallery3 from "../../assets/nw/7.png";
import gallery4 from "../../assets/nw/8.png";
import gallery5 from "../../assets/nw/9.png";
import gallery6 from "../../assets/nw/10.png";

const GallerySection = () => {
  const images = [gallery1, gallery2, gallery3, gallery4, gallery5, gallery6];

  return (
    <Box sx={{ py: 4, maxWidth: 1200, mx: "auto", px: 2 }}>
      <Typography
        variant="h4"
        align="center"
        fontWeight="bold"
        sx={{ mb: 1, color: "#333" }}
      >
        Our Project Gallery
      </Typography>

      <Typography
        variant="subtitle1"
        align="center"
        color="text.secondary"
        sx={{ mb: 5 }}
      >
        Explore our beautifully designed spaces and modern amenities
      </Typography>

      <Grid container spacing={3}>
        {images.map((src, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Box
              sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: 3,
                boxShadow: "0 4px 15px rgba(0,0,0,0.1)",
                cursor: "pointer",
                "&:hover .overlay": {
                  opacity: 1,
                },
                "&:hover img": {
                  transform: "scale(1.05)",
                },
              }}
            >
              {/* Image */}
              <Box
                component="img"
                src={src}
                alt={`Gallery ${index + 1}`}
                sx={{
                  width: "100%",
                  height: 260,
                  objectFit: "cover",
                  borderRadius: 3,
                  transition: "transform 0.4s ease",
                }}
              />

              {/* White overlay on hover */}
              <Box
                className="overlay"
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  backgroundColor: "rgba(255,255,255,0.3)",
                  opacity: 0,
                  transition: "opacity 0.3s ease",
                  borderRadius: 3,
                }}
              />
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default GallerySection;
